import React from "react";
import './chapter.css';

export default function ApporteurAffaires() {
  return (
    <section className="chapter">
      <header className="chapter__header">
        <h2 className="chapter__title">Apporteur d'affaires</h2>
        <p className="chapter__subtitle">
          Chacun peut être un apporteur d'affaires pour les autres. Pourquoi ? Parce que chacun d'entre nous a un réseau : familial, sportif, associatif, politique. <br />
          Et chacun entend quotidiennement des personnes qui se "plaignent" : je ne trouve pas de candidats, je ne trouve pas de fournisseurs, personne ne fait cela. <br />
          Si les politiques sont les experts en transmission d'information, les personnes, comme vous et moi, ne sont à l'écoute que de ce qui les intéresse. <br />
          Pour exemple : quand j'étais informaticien et expert en bases de données Oracle, je n'avais que faire des besoins de mes clients en développement DotNet, en compétences Jahia, ou encore en architecture réseau. <br />
          Erreur ! C’était une information précieuse qui entrait dans mon oreille pour se perdre aussitôt à l'intérieur. En vieillissant, j'ai compris que ces informations avaient de la valeur, d'autant plus quand les temps deviennent plus difficiles, comme en ce moment. <br />
          Alors, il était temps de mettre ce projet à disposition des Romands et de permettre à toute entreprise, freelance, ou commercial retraité de transmettre à ceux que cela intéresse les informations qu'ils obtiennent de leur réseau. <br />
          <br />
          ET, en tant que membre du réseau, pouvoir recevoir des informations qui VOUS intéressent.
        </p>
      </header>

      <div className="chapter__block">
        <h3 className="chapter__block-title">Qui peut devenir apporteur d'affaires</h3>
        <p className="chapter__block-text">
          Si vous êtes enregistré dans le registre des entreprises suisses, en tant qu'indépendant, en Sàrl ou SA, vous pouvez rejoindre le projet et participer à son bon fonctionnement. <br />
          Vous pouvez demander une clef personnelle et unique par SMS puis vous enregistrer sur le site&nbsp;<br/>
          <a href="https://open-market.ch/registration" target="_blank" rel="noopener noreferrer">https://open-market.ch/registration</a>. <br />
          L'équipe, après avoir effectué les contrôles nécessaires, vous donnera accès à la plateforme. Votre numéro d'adhérent vous permettra de transmettre les opportunités de votre réseau ainsi que la commission demandée.
        </p>
        <p className="chapter__block-text">
          Les personnes enregistrées pour leur savoir-faire verront vos opportunités et prendront contact avec vous si elles estiment pouvoir apporter la solution. <br />
          À partir de ce moment-là, la plateforme aura joué son rôle. <br />
          Elle ne prend aucune commission ni pourcentage sur la transaction.
        </p>
      </div>

      <div className="chapter__block">
        <h3 className="chapter__block-title">Avantages</h3>
        <p className="chapter__block-text">
          Ainsi, les opportunités que vous rencontrez ne sont plus perdues, elles servent à d'autres adhérents, dont certains pourraient proposer des opportunités qui vous intéressent.
        </p>
      </div>

      <div className="chapter__block">
        <h3 className="chapter__block-title">Comment cela coûte</h3>
        <p className="chapter__block-text">
          Pour la première année de fonctionnement, il a été décidé de ne pas facturer d'abonnement. <br />
          Vous recevrez un bulletin de versement avec CHF 20.- comme participation aux frais de fonctionnement, indépendamment du fait que la plateforme vous fournisse des opportunités ou que quelqu'un soit intéressé par celles que vous proposerez. <br />
          Par la suite, si vous souhaitez rester adhérent parce que vous y trouvez un intérêt, en tant que "early adopter", <br />
          vous paierez un abonnement de CHF 240.-/an (hors TVA), soit 50 % du prix normal que paieront <br />
          ceux qui sont frileux, pas sûrs de vouloir rejoindre ce projet innovant, et qui préfèrent attendre qu'il soit à sa vitesse de croisière pour s'inscrire. <br />
          <br />
          Le prix annuel standard a été fixé à CHF 480.- (hors TVA).
        </p>
      </div>
    </section>
  );
}
